import { render, staticRenderFns } from "./DeliveryUser.vue?vue&type=template&id=b1d914da&scoped=true&"
import script from "./DeliveryUser.vue?vue&type=script&lang=js&"
export * from "./DeliveryUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d914da",
  null
  
)

export default component.exports